import { render, staticRenderFns } from "./Stop.vue?vue&type=template&id=920b3906&scoped=true&"
import script from "./Stop.vue?vue&type=script&lang=js&"
export * from "./Stop.vue?vue&type=script&lang=js&"
import style0 from "./Stop.vue?vue&type=style&index=0&id=920b3906&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920b3906",
  null
  
)

export default component.exports